import { useState } from 'react'
import { useVerificationFlow } from '../../../Components/shared/VerificationFlow'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../store'
import { deleteTeamMembership } from '../../../store/slices/homebotNetwork/clientTeamMemberships'
import * as Sentry from '@sentry/browser'

export const useRemovePartnerStep = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { state, dispatch: dispatchVerificationFlow } = useVerificationFlow()
  const [isLoading, setIsLoading] = useState(false)
  const { currentPartnerType } = state

  const getMembership = () => {
    switch (currentPartnerType) {
      case 'RealEstateAgent':
        return state.realEstateAgentMembership
      case 'LoanOfficer':
        return state.loanOfficerMembership
      case 'InsuranceAgent':
        return state.insuranceAgentMembership
      default:
        return state.loanOfficerMembership
    }
  }
  const membership = getMembership()

  /**
   * Handles the cancel button click
   */
  const onCancel = () => {
    dispatchVerificationFlow({ type: 'CANCEL' })
  }

  /**
   * Handles the "Yes, Remove" button click
   */
  const removePartner = async () => {
    setIsLoading(true)
    try {
      const action = await dispatch(
        deleteTeamMembership({
          clientId: membership.clientId,
          membershipId: membership.id
        })
      )

      if (action.meta.requestStatus === 'fulfilled') {
        dispatchVerificationFlow({
          type: 'PARTNER_REMOVED',
          payload: {
            partnerData: membership,
            removedPartnerType: currentPartnerType
          }
        })
      }
    } catch (error) {
      Sentry.captureException(error)
      throw error
    } finally {
      setIsLoading(false)
    }
  }
  return {
    onCancel,
    removePartner,
    isLoading
  }
}
